<template>
  <div class="my-register-page">
    <div class="my-container">
      <b-row class="mb-2 align-items-center">
        <b-col>
          <h1>{{ $t("MuloqotList") }}</h1>
        </b-col>
        <!-- <b-col class="text-right">
          <button class="my-button my-bg-primary" @click="Refresh">
            <b-spinner v-if="Loading" small></b-spinner>
            {{ $t("refresh") }}
          </button>
        </b-col> -->
      </b-row>

      <!-- <div class="ml-tabs mt-2">
        <button
          v-for="tab in Tabs"
          :key="tab.id"
          class="ml-tab"
          :class="{ 'ml-tab--active': filter.applicationTypeId === tab.id }"
          @click="SelectTab(tab.id)"
        >
          {{ $t(tab.label) }}
        </button>
      </div> -->

      <b-table-simple bordered responsive class="mt-3">
        <b-thead>
          <b-tr variant="primary">
            <b-th style="vertical-align: middle">№</b-th>
            <b-th style="vertical-align: middle">{{ $t("docNumber") }}</b-th>
            <b-th style="vertical-align: middle">{{ $t("docDate") }}</b-th>
            <!-- <b-th style="vertical-align: middle">{{ $t("type") }}</b-th> -->
            <b-th style="vertical-align: middle">{{ $t("contractor") }}</b-th>
            <b-th style="vertical-align: middle">{{ $t("organization") }}</b-th>
            <b-th style="vertical-align: middle">{{ $t("employee") }}</b-th>
            <!-- <b-th style="vertical-align: middle">{{ $t("status") }}</b-th> -->
            <b-th style="vertical-align: middle" class="text-center">
              {{ $t("actions") || "Amallar" }}
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(item, index) in Rows" :key="index">
            <b-td class="text-nowrap">
              {{ (filter.page - 1) * filter.pageSize + index + 1 }}
            </b-td>
            <b-td class="text-nowrap">{{ item.docNumber }}</b-td>
            <b-td class="text-nowrap">{{ item.docDate }}</b-td>
            <!-- <b-td>{{ item.applicationTypeName || item.applicationType }}</b-td> -->
            <b-td>{{ item.contractor }}</b-td>
            <b-td>{{ item.organization }}</b-td>
            <b-td>{{ item.person }}</b-td>
            <!-- <b-td>{{ item.statusName || item.status }}</b-td> -->
            <b-td class="text-center">
              <b-link
                class="ml-view-btn"
                :title="$t('view') || 'Ko\'rish'"
                @click="View(item)"
              >
                <b-icon icon="eye" font-scale="1.2"></b-icon>
              </b-link>
            </b-td>
          </b-tr>
          <b-tr v-if="!Rows.length">
            <b-td colspan="8" class="text-center text-muted">
              {{ $t("noData") }}
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <div>
        <b-pagination
          v-model="filter.page"
          :total-rows="filter.totalRows"
          :per-page="filter.pageSize"
          first-number
          last-number
          @input="Refresh"
          class="mb-0 mt-1 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <b-icon icon="chevron-double-left" size="18" />
          </template>
          <template #next-text>
            <b-icon icon="chevron-double-right" size="18" />
          </template>
        </b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BSpinner,
  BTableSimple,
  BThead,
  BTbody,
  BTr,
  BTh,
  BTd,
  BPagination,
  BIcon,
  BLink,
} from "bootstrap-vue";
import InspectionService from "@/services/inspection.service";

export default {
  components: {
    BRow,
    BCol,
    BSpinner,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BPagination,
    BIcon,
    BLink,
  },
  data() {
    return {
      Loading: false,
      Rows: [],
      Tabs: [
        { id: null, label: "All" },
        { id: 1, label: "Muloqot" },
        { id: 2, label: "Profilaktika" },
        { id: 3, label: "Tekshiruv" },
      ],
      filter: {
        applicationTypeId: 1,
        search: "",
        sortBy: "",
        orderType: "asc",
        page: 1,
        pageSize: 20,
        totalRows: 0,
      },
    };
  },
  created() {
    this.Refresh();
  },
  methods: {
    View(item) {
      if (!item || !item.id) return;
      this.$router.push({
        name: "MuloqotListView",
        params: { id: item.id },
      });
    },
    SelectTab(id) {
      if (this.filter.applicationTypeId === id) return;
      this.filter.applicationTypeId = id;
      this.filter.page = 1;
      this.Refresh();
    },
    Refresh() {
      this.Loading = true;
      InspectionService.GetList(this.filter)
        .then((res) => {
          this.Rows = res.data.rows || [];
          this.filter.totalRows = res.data.total || 0;
          this.Loading = false;
        })
        .catch((error) => {
          this.Loading = false;
          this.makeToast(
            (error.response && error.response.data) || error.message,
            "error"
          );
        });
    },
    makeToast(message, type) {
      let a = "";
      if (message && message.status == 500) {
        a = message.title;
      } else if (message && message.status == 400 && message.errors) {
        const errors = Object.values(message.errors);
        a = errors.map((el, i) => i + 1 + "." + el).join("\n");
      } else {
        a = message;
      }
      this.$toast.open({
        message: a,
        type: type,
        duration: 5000,
        dismissible: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.ml-view-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  color: $primary;
  background: #eaf2ff;
  transition: background-color 0.2s, color 0.2s;
  cursor: pointer;

  &:hover {
    background: $primary;
    color: #fff;
  }
}

.ml-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.ml-tab {
  border: 1.5px solid #d1d5db;
  background: #f7f7f7;
  color: #374151;
  border-radius: 12px;
  padding: 10px 22px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s, background-color 0.2s;

  &:hover {
    border-color: $primary;
    color: $primary;
  }

  &--active {
    background: $primary;
    border-color: $primary;
    color: #fff;
  }
}
</style>
